var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBotijaoP13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 35,
    viewBox: "0 0 24 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2132",
    "data-name": "Grupo 2132",
    transform: "translate(0.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Exclus\\xE3o_3",
    "data-name": "Exclus\\xE3o 3",
    transform: "translate(3.947)",
    fill: "#000FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.00040054321289 29.50050163269043 L 2.999700546264648 29.50050163269043 C 2.172760486602783 29.50050163269043 1.500000596046448 28.82733154296875 1.500000596046448 27.99990081787109 L 1.500000596046448 15.89512634277344 C 1.524835705757141 17.80371284484863 3.085544347763062 19.34880065917969 5.000400543212891 19.34880065917969 L 11.99970054626465 19.34880065917969 C 13.9145565032959 19.34880065917969 15.47526550292969 17.80371284484863 15.50010013580322 15.89512634277344 L 15.50010013580322 27.99990081787109 C 15.50010013580322 28.82733154296875 14.8273401260376 29.50050163269043 14.00040054321289 29.50050163269043 Z M 15.50010013580322 4.772463321685791 C 15.48031997680664 3.251949310302734 14.48626232147217 1.962049245834351 13.11494922637939 1.500000834465027 L 14.00040054321289 1.500000834465027 C 14.8273401260376 1.500000834465027 15.50010013580322 2.172760725021362 15.50010013580322 2.999700784683228 L 15.50010013580322 4.772463321685791 Z M 1.500000596046448 4.772463321685791 L 1.500000596046448 2.999700784683228 C 1.500000596046448 2.172760725021362 2.172760486602783 1.500000834465027 2.999700546264648 1.500000834465027 L 3.885151863098145 1.500000834465027 C 2.513838529586792 1.962049245834351 1.519780993461609 3.251949310302734 1.500000596046448 4.772463321685791 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13.99799919128418 28.00050163269043 C 13.9987268447876 27.99982833862305 13.99945449829102 27.99908638000488 14.00010013580322 27.99835586547852 L 14.00007915496826 20.43125534057617 C 13.3871603012085 20.69978904724121 12.71059226989746 20.84880065917969 11.99970054626465 20.84880065917969 L 5.000400543212891 20.84880065917969 C 4.28950834274292 20.84880065917969 3.612975120544434 20.69980430603027 3.000056266784668 20.43127059936523 L 3.000080585479736 27.99844551086426 C 3.000706434249878 27.99914741516113 3.001404523849487 27.99985694885254 3.00210165977478 28.00050163269043 L 13.99799919128418 28.00050163269043 M 14.00040054321289 31.00050163269043 L 2.999700546264648 31.00050163269043 C 1.34566056728363 31.00050163269043 5.447387820822769e-07 29.65443992614746 5.447387820822769e-07 27.99990081787109 L 5.447387820822769e-07 2.999700784683228 C 5.447387820822769e-07 1.345660805702209 1.34566056728363 8.163452207554656e-07 2.999700546264648 8.163452207554656e-07 L 14.00040054321289 8.163452207554656e-07 C 15.65444087982178 8.163452207554656e-07 17.00010108947754 1.345660805702209 17.00010108947754 2.999700784683228 L 17.00010108947754 27.99990081787109 C 17.00010108947754 29.65443992614746 15.65444087982178 31.00050163269043 14.00040054321289 31.00050163269043 Z M 5.000400543212891 2.817900896072388 C 3.897210597991943 2.817900896072388 2.999700546264648 3.715410709381104 2.999700546264648 4.818600654602051 L 2.999700546264648 15.84900093078613 C 2.999700546264648 16.95169067382812 3.897210597991943 17.84880065917969 5.000400543212891 17.84880065917969 L 11.99970054626465 17.84880065917969 C 13.10289096832275 17.84880065917969 14.00040054321289 16.95169067382812 14.00040054321289 15.84900093078613 L 14.00040054321289 4.818600654602051 C 14.00040054321289 3.715410709381104 13.10289096832275 2.817900896072388 11.99970054626465 2.817900896072388 L 5.000400543212891 2.817900896072388 Z",
    stroke: "none",
    fill: "#000FFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_1980",
    "data-name": "Ret\\xE2ngulo 1980",
    transform: "translate(-0.053 6)",
    fill: "#000FFF",
    stroke: "#000FFF",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 26,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 25,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_1981",
    "data-name": "Ret\\xE2ngulo 1981",
    transform: "translate(3.947 30)",
    fill: "#000FFF",
    stroke: "#000FFF",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 4,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotijaoP13);
export default __webpack_public_path__ + "static/media/Botijao-P13.3367eb8752ae0e5759f9bcab1e786916.svg";
export { ForwardRef as ReactComponent };